
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoySpecialPurposeTssPort as ObiSimplifiedBuoySpecialPurposeTssPortElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-special-purpose-tss-port.js';
 
 
 

 
 export const ObiSimplifiedBuoySpecialPurposeTssPort = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-special-purpose-tss-port',
   elementClass: ObiSimplifiedBuoySpecialPurposeTssPortElement,
   events: {
     
   }
  });
 
 